/** Snapshot of buildable cards. Unknown WB capacity falls back to the daily
 * allowance so optional calibration never becomes a publishing requirement. */
export function getBuildableCardCount(dailyAvailable: number | null, totalRemaining: number | null): number | null {
  const daily = typeof dailyAvailable === 'number' && Number.isSafeInteger(dailyAvailable) && dailyAvailable >= 0 ? dailyAvailable : null;
  const total = typeof totalRemaining === 'number' && Number.isSafeInteger(totalRemaining) && totalRemaining >= 0 ? totalRemaining : null;
  if (daily === 0 || total === 0) return 0;
  return daily === null ? null : total === null ? daily : Math.min(daily, total);
}
